<template>
    <div>

        <config-main-title>
            <span v-if="$route.meta.titulo && $route.meta.titulo.slice(0,3) == '...'">
                {{ $route.meta.titulo.slice(3) }}
            </span>
            <span v-else>
                Status {{ $route.meta.titulo }}
            </span>
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum Item identificado.'" 
                icon="fas fa-search"
                :action="'Incluir'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <small class="text-muted ml-3" v-if="dado.st_acao">{{ dado.st_acao }}</small>
                        <span class="badge badge-secondary ml-3" v-if="dado.js_configs && dado.js_configs.grupo">
                            {{ dado.js_configs.grupo }}
                        </span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div class="d-flex" v-else>
                            <div class="mr-3" v-if="dado.js_configs && dado.js_configs.pend" title="Pendência / Tarefa">
                                <i class="fa-solid fa-clipboard-list-check"></i>
                            </div>
                            <div v-if="dado.st_color">
                                <span class="badge" :class="'badge-' + dado.st_color">
                                    {{ dado.in_regra_ordem }}
                                    <i class="fas fa-palette"></i>
                                </span>
                            </div>

                            <template v-if="tem_acesso">
                                <button type="button" class="btn btn-sm btn-outline-secondary ml-3" @click="acessos(dado)" v-if="!outros_acessos || !outros_acessos.length">
                                    <i class="fas fa-user-lock mr-2"></i>
                                    {{ dado.acessos.length }}
                                </button>

                                <span class="ml-3" v-else>
                                    <button type="button" class="btn btn-sm btn-outline-secondary mr-1" @click="acessos(dado, outro)" v-for="(outro, iox) in outros_acessos" :key="iox"
                                        data-toggle="tooltip" data-placement="top" :title="'Acesso para: ' + outro.search">
                                        <i class="mr-2" :class="outro.icon" v-if="outro.icon"></i>
                                        {{ dado.acessos.filter(ac => ac.st_tipo == outro.id || ( !outro.id && !ac.st_tipo ) ).length }}
                                    </button>

                                    <i class="fas fa-lock ml-1"></i>
                                </span>
                            </template>
                        </div>
                    </span>
                </li>
            </div>

            <pre v-if="false">{{ outros_acessos }}</pre>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_contato_status ) ? '' : 'Novo' }}
                            Item
                            <span v-if="item && item.id_contato_status">
                                #{{ item.id_contato_status }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Nome do status..."
                                    :validate="validate"
                                    required
                                    v-model="item.st_contato_status" />
                            </div>
                        </div>
                        <template v-if="item.model_type == 'App\\azure\\medicoSolicitante' || item.model_type == 'App\\azure\\receita' || item.model_type == 'App\\azure\\atendimento' || item.model_type == 'App\\azure\\cuidadoPaciente'">

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        label="Informar Data"
                                        type="checkbox-group"
                                        :validate="validate"
                                        v-model="item.fl_informar_data" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Ordem"
                                        type="number"
                                        placeholder="Número de Ordem..."
                                        :validate="validate"
                                        v-model="item.in_regra_ordem" />
                                </div>
                            
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Id Externo"
                                        :validate="validate"
                                        v-model="item.st_id_externo" />
                                </div>
                            </div>

                        </template>
                        <template v-else-if="item.model_type == 'App\\azure\\tarefa'">
                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        label="Tarefa Pronta"
                                        type="checkbox-group"
                                        :validate="validate"
                                        v-model="item.js_configs.fl_pronta" />
                                </div>
                            </div>
                        </template>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Cor"
                                    type="select"
                                    :validate="validate"
                                    :optionsList="[
                                        { id: 'primary', search: 'Azul' },
                                        { id: 'success', search: 'Verde' },
                                        { id: 'danger', search: 'Vermelho' },
                                        { id: 'dark', search: 'Preto' },
                                        { id: 'secondary', search: 'Cinza' },
                                        { id: 'warning', search: 'Amarelo' },
                                        { id: 'info', search: 'Ciano' },
                                    ]"
                                    optionsData="id"
                                    v-model="item.st_color" />
                            </div>
                        </div>

                        <div class="d-flex flex-column mt-1 mb-3" v-if="item.st_color">
                            <span class="badge" :class="'badge-' + item.st_color">
                                &nbsp;
                            </span>
                        </div>

                        <!-- Obs Padrão -->
                         <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observação Padrão"
                                    type="textarea"
                                    rows="3"
                                    placeholder="Informada no lançamento..."
                                    :validate="validate"
                                    v-model="item.st_obs_padrao" />
                            </div>
                        </div>

                        <!-- Pendência -->
                        <div class="row mt-2" v-if="item.js_configs">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Pendência / Tarefa"
                                    :validate="validate"
                                    v-model="item.js_configs.pend" />
                            </div>

                            <template v-if="is_laudo">
                                <div class="col col-12">
                                    <az-input
                                        type="checkbox-group"
                                        label="Exibir na Entrega de Resultado"
                                        :validate="validate"
                                        v-model="item.js_configs.entrega" />
                                </div>
                            </template>
                        </div>

                        <!-- Infusão -->
                        <div class="row" v-if="is_infusao && item.js_configs">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Liberar Solicitação"
                                    :validate="validate"
                                    v-model="item.js_configs.lib_solic" />
                            </div>
                        </div>

                        <!-- Reembolso -->
                        <div class="row" v-if="is_reembolso && item.js_configs">
                            <div class="col col-12">
                                <az-input
                                    label="Grupo"
                                    :validate="validate"
                                    v-model="item.js_configs.grupo" />
                            </div>
                        </div>

                        <div class="row mt-3" v-if="is_reembolso && item.js_configs">
                            <div class="col col-12">
                                <az-input
                                    label="Arquivo Morto"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.js_configs.arquivo_morto" />
                            </div>
                        </div>

                        <!-- Tarefa de Laudo -->
                        <template v-if="is_laudo && item.js_configs && item.js_configs.pend">
                            <div class="row mt-3">
                                <div class="col col-12">
                                    <az-input
                                        label="Grupo/Serviço de Tarefa"
                                        placeholder="Não vinculada a tarefa..."
                                        type="select" 
                                        optionsMode="aql"
                                        service="tarefa_grupo_servicos.index" 
                                        :optionsParm="{ ativos: true, grupo: true }"
                                        optionsData="id_tarefa_grupo_servico"
                                        v-model="item.id_tarefa_grupo_servico">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="item.id_tarefa_grupo_servico">
                                                <span class="input-group-text small">
                                                    #{{ item.id_tarefa_grupo_servico }}
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <div class="alert alert-info small py-2 mt-1" v-if="item.id_tarefa_grupo_servico">
                                Ao selecionar um Grupo/Serviço de Tarefa, ao registrar esta ocorrência, uma tarefa será criada automaticamente para este serviço.
                            </div>
                        </template>

                        <!-- RPA -->
                        <div v-if="item.tem_rpa">
                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        type="checkbox-group"
                                        label="Verificar Status por RPA"
                                        v-model="item.js_configs.rpa_status" />
                                </div>
                            </div>

                            <az-sub-title title="Status para Atualização" class="mt-3">
                                <a href="#" @click.prevent="incluir_status(item)" class="card-link">
                                    <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                    Incluir
                                </a>
                            </az-sub-title>
                            <div v-if="!item.js_configs.status || !item.js_configs.status.length">
                                Nenhum status registrado.
                            </div>
                            <template v-else>
                                <div class="row" v-for="(status_item, isx) in item.js_configs.status" :key="isx">
                                    <div class="col col-12">
                                        <az-input
                                            sizing="sm"
                                            placeholder="Descrição"
                                            required
                                            :validate="validate"
                                            v-model="status_item.nome">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="remover_status(isx)">
                                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>

                                <div class="row mt-3">
                                    <div class="col col-12">
                                        <az-input
                                            label="Notificar"
                                            placeholder="Lista de e-mails separadas por ponto-e-vírgula..."
                                            v-model="item.js_configs.emails" />
                                    </div>
                                </div>
                            </template>

                            <br><br>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="contatoStatus" :id="item.id_contato_status" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_contato_status ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import EdicaoAcessos from '../shared/EdicaoAcessos.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            outros_acessos: [],
            is_reembolso: false, 
            is_infusao: false, 
        }
    },

    props: ['teste'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        EdicaoAcessos, 
        AzSubTitle, 
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        tem_acesso: function () { 
            return this.$route.meta.model == 'atendimento'
                || this.$route.meta.model == 'receita';
        },

        is_laudo: function () { 
            return this.$route.meta.model == 'laudo' ? true : false; 
        }

    },

    methods: { 
        remover_status(idx) { 
            this.item.js_configs.status.splice(idx, 1);
            this.$forceUpdate();
        },

        incluir_status(item) { 
            if ( !item.js_configs.status ) { 
                item.js_configs.status = [];
            }

            item.js_configs.status.push({ 
                nome: "", 
            });

            this.$forceUpdate();
        },

        acessos(item, outro) { 
          this.$refs.acessos.abrir(
              'App\\azure\\contatoStatus', 
              item.id_contato_status, 
              _.get(outro, 'search'), 
              _.get(outro, 'id')
            );
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_contato_status: null, 
                st_contato_status: "", 
                st_color: "primary",
                fl_ativo: true, 
                model_type: 'App\\azure\\' + this.$route.meta.model,
                id_tarefa_grupo_servico: "", 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'contato_status',
                func: 'index',
                parms: { 
                    model: this.$route.meta.model, 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = null; 

            if ( !item.js_configs ) { 
                item.js_configs = { 
                    rpa_status: false, 
                    status: [],
                };
            } 

            this.$nextTick(() => { 
                this.item = _.cloneDeep (item);
    
                $('#edicaoModal').modal('show');
            });
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'contato_status',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'contato_status',
                dados: item,
            });

        },
    },

    mounted () { 
        let titulo = ( this.$route.meta.titulo && this.$route.meta.titulo.slice(0,3) == '...' ) 
            ? this.$route.meta.titulo.slice(3)
            : "Status " + this.$route.meta.titulo;

        console.log('titulo', titulo);

        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros"},
            { name: titulo },
        ];

        if ( this.$route.meta.titulo == 'Reembolso' ) { 
            this.is_reembolso = true;
        } else if ( this.$route.meta.titulo == 'Validação de Prescrição' ) { 
            this.is_infusao = true;
        }

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        let id_perm;

        if ( this.$route.params.outros_acessos ) { 
            this.outros_acessos = this.$route.params.outros_acessos;
        }

        switch (this.$route.meta.model) {
            case 'atendimento':
                id_perm = 85;
                break;

            case 'tarefa':
                id_perm = 96;
                break;
        }

        if ( id_perm ) { 
            this.$util.valid_permissao(this, id_perm, this.load);
        } else { 
            this.load();
        }

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>